import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { ConsultarParametrosSistemaRequest, Types } from './types';

// ACTIONS
import {
	consultarParametrosSistemaSuccess,
	consultarParametrosSistemaFailure,
} from './actions';

function* consultarParametrosSistema(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarParametrosSistemaRequest } = request;

	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as ConsultarParametrosSistemaRequest;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`parametros-sistema`,
		body,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarParametrosSistemaSuccess(response));
	} else {
		yield put(consultarParametrosSistemaFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTAR_PARAMETROS_SISTEMA, consultarParametrosSistema),
]);
